import React, { Component } from "react";
import { connect } from "react-redux";
import { Route, withRouter, Redirect, Switch } from "react-router-dom";
import { DragDropContext } from "react-dnd";
import MultiBackend from "react-dnd-multi-backend";
import HTML5toTouch from "react-dnd-multi-backend/lib/HTML5toTouch";
import { NotificationContainer } from 'react-notifications';
import 'react-notifications/lib/notifications.css';
/*** components ***/
import PrivateWrapper from "./components/Wrappers/PrivateWrappers";
import { Header } from "./components/Header/Header";
import { Page404 } from "./containers/Page404";
import BuildStep from "./containers/steps/BuildSteps";
import Step1 from "./containers/steps/step1/index";
import Finish from "./containers/steps/FinishStep/index";
import LidCustomPreview from "./containers/steps/BuildSteps/BuildsComponent/LidCustomPreview";

import { pushDataFromForm } from "./actions/pushDataFromForm";
import {getUrlParams} from "./helpers/getUrlParams";

/***styles***/
import "./css/style.css";

class App extends Component {
  componentDidMount() {
    const urlParams = getUrlParams(this.props.location.search);
      /**
       * if we have data from form(which we receive from  http://www.mm-mannhart.ch/kabelschaechte-app/)
       * then parse this data and send in future to API
       */
    if (urlParams && urlParams.from_email) {
      this.props.pushDataFromForm(urlParams);
    }
  }
  render() {
    return (
      <div>
        <Header />
        <Switch>
          <Route
            exact
            path="/"
            render={() => {
              return <Redirect to={"/step/1"} />;
            }}
          />
          <Route
            exact
            path={"/step"}
            render={() => {
              return <Redirect to={"/step/1"} />;
            }}
          />
          <PrivateWrapper path={"/step/1"} component={Step1} />
          <PrivateWrapper path={"/step/6"} component={Finish} />
          <PrivateWrapper path={"/step/:step"} component={BuildStep} />
          <Route component={Page404} />
        </Switch>
        <LidCustomPreview />
        <NotificationContainer/>
      </div>
    );
  }
}

const mapStateToDispatch = {
  pushDataFromForm
};

const mapStateToProps = () => {
  return {};
};

export default withRouter(
  DragDropContext(MultiBackend(HTML5toTouch))(
    connect(mapStateToProps, mapStateToDispatch)(App)
  )
);



// WEBPACK FOOTER //
// ./src/App.js